import React, { useState } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Dropdown, DropdownToggle, DropdownMenu, Row, Col, Spinner } from "reactstrap";
import SimpleBar from "simplebar-react";
import FeatherIcon from "feather-icons-react";
import { withTranslation } from "react-i18next";
import { useHeaderNotifications } from "../../../hooks/useHeaderNotifications";
import { formatNotificationTime } from "../../../utils/notificationBuilders";

const NotificationDropdown = (props: any) => {
  const [menu, setMenu] = useState(false);
  const {
    notifications,
    unreadCount,
    loading,
    markAsRead,
    markAllAsRead,
  } = useHeaderNotifications();

  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="dropdown d-inline-block"
        tag="li"
      >
        <DropdownToggle
          className="btn header-item noti-icon position-relative"
          tag="button"
          id="page-header-notifications-dropdown"
        >
          <FeatherIcon icon="bell" className="icon-lg" />
          {unreadCount > 0 ? (
            <span className="badge bg-danger rounded-pill">
              {unreadCount > 99 ? "99+" : unreadCount}
            </span>
          ) : null}
        </DropdownToggle>

        <DropdownMenu className="dropdown-menu-lg dropdown-menu-end p-0">
          <div className="p-3">
            <Row className="align-items-center">
              <Col>
                <h6 className="m-0"> {props.t("Notifications")} </h6>
              </Col>
              <div className="col-auto">
                {unreadCount > 0 ? (
                  <button
                    type="button"
                    className="btn btn-link btn-sm p-0"
                    onClick={markAllAsRead}
                  >
                    Mark all read
                  </button>
                ) : (
                  <span className="small text-muted">All caught up</span>
                )}
              </div>
            </Row>
          </div>

          <SimpleBar style={{ height: "230px" }}>
            {loading && notifications.length === 0 ? (
              <div className="text-center py-4">
                <Spinner size="sm" color="primary" />
              </div>
            ) : notifications.length === 0 ? (
              <div className="text-center text-muted py-4 px-3">
                No unread notifications
              </div>
            ) : (
              notifications.map((item) => (
                <Link
                  key={item.id}
                  to={item.to}
                  className="text-reset notification-item"
                  onClick={() => markAsRead(item.id)}
                >
                  <div className="d-flex">
                    <div className="avatar-sm me-3">
                      <span
                        className={`avatar-title bg-${item.tone} rounded-circle font-size-16`}
                      >
                        <i className={item.icon} />
                      </span>
                    </div>
                    <div className="flex-grow-1">
                      <h6 className="mt-0 mb-1">{item.title}</h6>
                      <div className="font-size-12 text-muted">
                        <p className="mb-1">{item.message}</p>
                        <p className="mb-0">
                          <i className="mdi mdi-clock-outline" />{" "}
                          {formatNotificationTime(item.createdAt)}
                        </p>
                      </div>
                    </div>
                  </div>
                </Link>
              ))
            )}
          </SimpleBar>
          <div className="p-2 border-top d-grid">
            <Link
              className="btn btn-sm btn-link font-size-14 btn-block text-center"
              to="/orders-list"
              onClick={() => setMenu(false)}
            >
              <i className="mdi mdi-arrow-right-circle me-1"></i>{" "}
              {props.t("View all")}{" "}
            </Link>
          </div>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
};

export default withTranslation()(NotificationDropdown);

NotificationDropdown.propTypes = {
  t: PropTypes.any,
};
